import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Case } from '../../../../../../../../../_base-shared/models/Case/Case';
import { CaseStatusLog } from '../../../../../../../../../_base-shared/models/Case/CaseStatusLog';
import { CaseService } from '../../../../case.service';

@Component({
  selector:    'app-case-status-log',
  templateUrl: './case-status-log.component.html',
  styles:      [],
})
export class CaseStatusLogComponent implements OnInit, OnDestroy {
  @Input() case: Case;
  public isLoading                           = 0;
  public caseStatusLogs: Array<CaseStatusLog>;
  private subscriptions: Array<Subscription> = [];

  constructor(private router: Router,
              private route: ActivatedRoute,
              private caseService: CaseService) {
  }

  ngOnInit(): void {
    this.fetchLogs(this.case.id);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private fetchLogs(caseId: number) {
    this.isLoading++;
    this.subscriptions.push(
        this.caseService.getStatusLogs(caseId, {all: 1}).pipe(finalize(() => this.isLoading--)).subscribe(
            result => this.caseStatusLogs = result.data,
        ),
    );
  }
}
